import {ThreeBuiltInEquipment} from '../ThreeBuiltInEquipment';

export class ThreeBuiltinDishwasherEquipment extends ThreeBuiltInEquipment {


}